import { SET_BANNERS, ADD_BANNER, REMOVE_BANNER } from '../types/bannersTypes';

const initialState = {
  list: [],
  loading: false,
};

const bannersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BANNERS:
      return { ...state, list: action.payload.data };
    case ADD_BANNER:
      return { ...state, list: [...state.list, action.payload] };
    case REMOVE_BANNER:
      return { ...state, list: state.list.filter((b) => b.id !== action.payload) };
    default:
      return state;
  }
};

export default bannersReducer;
